import styled from 'styled-components';

const IconButton = styled.div`
  pointer-events: ${p => (p.mood === 'disabled' ? 'none' : 'auto')};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme.color.background};
  background-color: ${(p) => p.theme.color.background};
  cursor: pointer;
  transition: all ${(p) => p.theme.duration.s} linear;
  svg {
    fill: ${(p) => p.theme.color.gray};
    path {
      fill: ${(p) => p.theme.color.gray};
    }
    circle {
      fill: ${(p) => p.theme.color.gray};
    }
  }

  &:hover {
    border: 1px solid ${(p) => p.theme.color.pale};

    svg {
      fill: ${(p) => p.theme.color.turquoise};
      path {
        fill: ${(p) => p.theme.color.turquoise};
      }
      circle {
        fill: ${(p) => p.theme.color.turquoise};
      }
    }
  }
  &:active {
    transform: scaleX(0.95) scaleY(0.95) scaleZ(0.95);

    svg {
      transform: scale(0.8);
    }
  }
`;

export const Styled = {
  IconButton,
};
